import {
  Dispatch, SetStateAction, useId, useMemo,
} from 'react';
import Select from 'react-select';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { selectStyles } from './constants';
import { Nullable, WidgetType } from './types';
import { WidgetStep } from './WidgetStep';

export type WidgetTypeOption = { value: WidgetType, label: string };

type WidgetTypeSelectProps = {
  value: Nullable<WidgetTypeOption>
  setter: Dispatch<SetStateAction<Nullable<WidgetTypeOption>>>,
  step: number,
  className?: string,
};

function WidgetTypeSelect({
  value, setter, step, className,
}: WidgetTypeSelectProps) {
  const { t } = useOTSTranslation('common');
  const titleId = useId();

  const widgetTypeOptions: ReadonlyArray<WidgetTypeOption> = useMemo(() => [
    { value: WidgetType.SINGLE_RESORT, label: t('widget.singleResort') },
    { value: WidgetType.LIST_OF_RESORTS, label: t('widget.listOfResorts') },
    { value: WidgetType.SINGLE_REGION, label: t('widget.singleRegion') },
  ], []);

  return (
    <WidgetStep step={step} title={t('widget.chooseWidgetType')} titleId={titleId} className={className}>
      <Select
        id="type.select"
        inputId="widget-type"
        aria-labelledby={titleId}
        placeholder={t('widget.pleaseSelect')}
        onChange={setter}
        value={value}
        isSearchable={false}
        options={widgetTypeOptions}
        styles={selectStyles<WidgetTypeOption>()}
      />
    </WidgetStep>
  );
}

export default WidgetTypeSelect;
